import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import Pagination from '@material-ui/lab/Pagination';
import {
    Grid,
    Accordion,
    AccordionSummary,
    Typography,
    AccordionDetails,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Chip from '@material-ui/core/Chip';

import LearningContentsContext from '../../../context/learningContentContext/learningContents-context';
import { Coin } from '../../shared/component'

import { getIconLearningContent } from '../../../utils/helpers/icon/iconHelper'
import { setLearningContentSession, removeLearningContentFromSession, getLearningContentLevel } from '../../../utils/helpers/others/SessionHelper';

import useStyles from '../../../styles/components/learningcontent/stylesLCRecommendHolder'

const LearningContentsRecommendHolder = () => {
    const classes = useStyles()
    const history = useHistory();
    const { learningContentsContext } = useContext(LearningContentsContext);
    const learningContentSession = JSON.parse(localStorage.getItem('learningContent'));
    const rowsPerPage = 5;
    const [page, setPage] = React.useState(1);
    const handlePageChange = (event, value) => setPage(value);

    const selectLearningContent = (learningContentId, isAccessible, isRecommended, isCompleted,isSecretCodeClaim) => {
        const learningContent = {
            learningContentCategoryId: learningContentSession.learningContentCategoryId,
            learningContentCategoryName: learningContentSession.learningContentCategoryName,
            learningContentId,
            isAccessible,
            isRecommended,
            isCompleted,
            isSecretCodeClaim
        };

        removeLearningContentFromSession();
        setLearningContentSession(JSON.stringify(learningContent));
        history.push("/LearningContent");
    }

    return (
        <>
            {learningContentsContext &&
                <Grid item xs={12} classes={{ root: classes.rootGridContainer }}>
                    <Accordion
                        classes={{
                            root: classes.rootAccordion,
                            rounded: classes.roundedAccordion,
                        }}
                    >
                        <AccordionSummary
                            classes={{
                                root: classes.rootAccordionSummary,
                                content: classes.contentAccordionSummary,
                                expanded: classes.expandedAccordionSummary,
                                expandIcon: classes.expandIconAccordionSummary,
                            }}
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Typography classes={{ root: classes.rootContent }}>Recommended Learning Resources</Typography>
                            <Typography classes={{ root: classes.rootContent }} className={classes.secondaryHeading}>Available : {learningContentsContext.recommendLearningContents.length - learningContentsContext.completedRecommendedLearningContentsCount}  Completed: {learningContentsContext.completedRecommendedLearningContentsCount}</Typography>
                        </AccordionSummary>
                        <AccordionDetails classes={{ root: classes.rootAccordionDetails }}>
                            {
                                // learningContentsContext.recommendLearningContents.length > 0 && getLearningContentLevel() < 1 ? 
                                // <div style = {{color: 'red', fontWeight: 'bold', marginBottom: '15px', textAlign: 'left'}}>
                                //     You have not completed the survey sections for related trait so you will not be able to gain coins. However, feel free to do the quiz to learn more about the topics!
                                // </div>
                                // : 
                                // <></>
                            }                        
                            {learningContentsContext.recommendLearningContents.length > 0 ? learningContentsContext.recommendLearningContents.slice((page - 1) * rowsPerPage, page * rowsPerPage).map((item, idx) => (
                                <Grid
                                    style={{ backgroundColor: item.isTriedBefore ? 'transparent' : 'rgba(98, 197, 218, 0.5)' }}
                                    key={idx}
                                    container
                                    classes={{ root: classes.rootGridItem }}
                                    alignItems="center"
                                    justify="center"
                                    onClick={() => selectLearningContent(item.learningContentId, item.isAccessible, item.isRecommended, item.isCompleted,item.isSecretCodeClaim)}
                                >
                                    <Grid item xs={8}>
                                        <Grid container alignItems="center" justify="flex-start">
                                            <div>
                                                {
                                                    <Chip size = "small" label = {'SubCategory : ' + item.traitCategoryName}>                                                        
                                                    </Chip>
                                                }
                                                {'  '}
                                                {
                                                    item.isCompleted ?
                                                        <Chip size="small" style={{ backgroundColor: '#4DD091', color: 'white' }}
                                                            label={`Completed`}
                                                        />
                                                        :
                                                        item.isTriedBefore ?
                                                        <Chip size="small" style={{ backgroundColor: '#cd950c', color: 'white' }}
                                                            label={`Ongoing`}
                                                        />
                                                        :
                                                        <Chip size="small" style={{ backgroundColor: '#ff5768', color: 'white' }}
                                                            label = {`New`}
                                                        />                                                    
                                                }
                                            </div>
                                            <div className={classes.learningContentTitle}>{item.learningContentName}</div>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <Grid container alignItems="center" justify="flex-end">
                                            <div className={classes.rewardContainer}>
                                                <Coin
                                                    // coin = {getLearningContentLevel() < 1 ? 0 : item.isCompleted ? item.rewardPoint / 2 : item.rewardPoint}
                                                    coin={!item.isCompleted && item.isTriedBefore ? item.rewardPoint / 2 : item.rewardPoint}
                                                    size="medium"
                                                />
                                            </div>
                                            <div className={classes.iconContainer}>
                                                <NavigateNextIcon/>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            ))
                                :
                                <Grid
                                    container
                                    alignItems="center"
                                    justify="center"
                                >No recommendation available</Grid>
                            }
                        </AccordionDetails>
                        {
                            <Grid
                                container
                                direction={'row'}
                                alignContent={'center'}
                                justify={'center'}
                                classes={{ root: classes.rootGridPagination }}
                            >
                                <Pagination count={Math.ceil(learningContentsContext.recommendLearningContents.length / 5)}
                                    variant="outlined"
                                    shape="rounded"
                                    color="secondary"
                                    page={page}
                                    onChange={handlePageChange}
                                    hidePrevButton hideNextButton />
                            </Grid>
                        }
                    </Accordion>
                </Grid>
            }
        </>
    )
}

export default LearningContentsRecommendHolder;